export const ONBOARDING_STAGES = [
  'company_context',
  'objections',
  'faqs',
  'landmines',
  'competitors',
] as const;

export type OnboardingStage = (typeof ONBOARDING_STAGES)[number];

export const isOnboardingStage = (value: unknown): value is OnboardingStage =>
  typeof value === 'string' && (ONBOARDING_STAGES as readonly string[]).includes(value);

export const ONBOARDING_REVIEW_SECTIONS = [...ONBOARDING_STAGES, 'claims', 'playbooks'] as const;
export type OnboardingReviewSection = (typeof ONBOARDING_REVIEW_SECTIONS)[number];
export const isOnboardingReviewSection = (value: unknown): value is OnboardingReviewSection =>
  typeof value === 'string' && (ONBOARDING_REVIEW_SECTIONS as readonly string[]).includes(value);

export const ONBOARDING_STAGE_LABELS: Record<OnboardingStage, string> = {
  company_context: 'Company Context',
  objections: 'Objections',
  faqs: 'FAQs',
  landmines: 'Landmines',
  competitors: 'Competitors',
};

export type ImproveItemCurrent =
  | { value: string | string[] }
  | { question: string; answer: string };

export type SmartWizardRequest =
  | {
      id: number;
      kind: 'add';
      stage: OnboardingStage;
      pendingQuestion?: string;
    }
  | {
      id: number;
      kind: 'improve';
      stage: OnboardingStage;
      contextLabel: string;
      current: ImproveItemCurrent;
      onApply: (updated: ImproveItemCurrent, changes: string[]) => void | Promise<void>;
    };
